module.exports = __webpack_public_path__ + "img/tele2-slider_7fb0a57918860e41264dd98c8ace6d31.gif";


//////////////////
// WEBPACK FOOTER
// ./client/img/tele2-slider.gif
// module id = 256
// module chunks = 0